import React, { useRef } from 'react'
import Board from './Board'
import Panel from './Panel'

export const Game = ({c, ejercicio, avanzarEj}) => {
    const totalCorrectas = useRef(0);
    
    const contarCorrectas = (ejercicio) =>{
        //se limpia total correctas
        totalCorrectas.current = 0;
        //se setea total correctas de acuerdo con el ejercicio que llega

        for(let i=0; i< ejercicio.items.length; i++){
            (ejercicio?.items[i]?.res)&&totalCorrectas.current++
        }
    }
    
    contarCorrectas(ejercicio);

    return (
        <div className="wrapper" >
        <Board 
            c={c}
            totalCorrectas={totalCorrectas.current} 
            ejercicio={ejercicio}
            avanzarEj={avanzarEj}
        />

        <Panel items={ejercicio.items} />
        </div>
    )
}

export default Game;